export default {
  apiUrl: '/api/signup',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: '',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__slot:actions',
      title: '확인 취소',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<i style="white-space: nowrap">아이디</i>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'division',
      title: '<i style="white-space: nowrap">소속</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'grade',
      title: '<i style="white-space: nowrap">등급</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'email',
      title: '<p style="white-space: nowrap">가입한 이메일</p>',
      sortField: 'email',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name',
      title: '<i style="white-space: nowrap">이름</i>',
      sortField: 'name',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'phone',
      title: '<i style="white-space: nowrap">핸드폰 번호</i>',
      sortField: 'phone',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'pickup_place_name',
      title: '<p style="white-space: nowrap">매장명</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'storeField',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/signup-management/Config.js